import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import I18n from "i18next";
import MzAlert from "@markaaz/ui/MzAlert";
import MzButton from "@markaaz/ui/MzButton";
import NameMatchingParameter from "./NameMatchingParameter";
import ApprovalStatus from "components/monitoring/business/ApprovalStatus";
import Loading from "components/common/Loading";

const sx = {
  heading: {
    color: "darkBlue.c100"
  },
  body: {
    color: "darkBlue.c100",
    marginTop: "12px",
    marginBottom: "40px",
    maxWidth: "860px"
  },

  footer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "40px 5px",
    gap: "20px"
  }
};

export default function NameMatching({
  data,
  values,
  submitInProgress,
  ShowNameMatchNotification,
  onSubmit,
  onSliderChange,
  onReset,
  onAlertClose,
  isPartnerChanged
}) {
  const t = I18n.getFixedT(null, null, "applicationOnboarding");
  return (
    <>
      {!values ? (
        <Loading />
      ) : (
        <Box>
          <Typography variant="h6" sx={sx.heading}>
            {" "}
            {t("p2B Name Matching Parameter")}{" "}
          </Typography>
          <Typography variant="body2" sx={sx.body}>
            {" "}
            {t("p2B description")}{" "}
          </Typography>
          <Box>
            {data.map((item) => {
              return (
                <NameMatchingParameter
                  key={item.label}
                  label={item.label}
                  items={item.items}
                  values={values}
                  onSliderChange={onSliderChange}
                />
              );
            })}
          </Box>
          <Stack direction="row" mt={8} gap={10} alignItems="center">
            <MzButton
              variant={isPartnerChanged ? "contained" : "outlined"}
              color="error"
              size="large"
              onClick={onReset}
              disabled={isPartnerChanged}
            >
              {t("reset")}
            </MzButton>
            <MzButton
              variant="contained"
              color="primary"
              size="large"
              loading={submitInProgress}
              onClick={onSubmit}
              disabled={isPartnerChanged}
            >
              {t("submit")}
            </MzButton>
            {ShowNameMatchNotification.message && (
              <MzAlert
                sx={{ alignItems: "center" }}
                severity={ShowNameMatchNotification.type === "success" ? "success" : "error"}
                onClose={() => {
                  onAlertClose("nm");
                }}
              >
                {ShowNameMatchNotification.message}
              </MzAlert>
            )}
          </Stack>
          <Box mt={5}>
            <ApprovalStatus data={values} />
          </Box>
        </Box>
      )}
    </>
  );
}
